import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import { DatePerformed } from '../../../types/date-performed';
import { updateDatePerformed } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateDatePerformedReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        dayXmlId?: string;
        monthXmlId?: string;
        yearXmlId?: string;
        dateXmlId?: string;
        newValue: string;
    },
): Readonly<FormState> {
    const oldDatePerformed = state.participantCopies[state.selectedParticipantCopyId].functionalElements[
        props.id
    ] as DatePerformed;

    // if the input value is the same as the value of the functional element, then return the state
    if (oldDatePerformed.date === props.newValue) {
        return state;
    }

    // Create updated date entry
    const newDatePerformed: { [key: string]: Readonly<DatePerformed> } = {};
    newDatePerformed[props.id] = { ...oldDatePerformed, date: props.newValue };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDatePerformed,
    });
}

export const dateReducer = [
    on<FormState, Array<typeof updateDatePerformed>>(updateDatePerformed, updateDatePerformedReducer),
];
